<template>
    <div>
        <h5>Manage Pool</h5>
        <div class="card">
            <Button label="Create a pool" @click="formDialog = true" />
        </div>
        <!-- Pool table component -->
        <pool-table />
        <!-- Pool form component -->
        <pool-form v-if="formDialog" @hide-dialog="formDialog = false" />
    </div>
</template>

<script setup>
import PoolTable from '../components/PoolTable.vue';
import PoolForm from '../components/PoolForm.vue';
import { ref } from 'vue';

const formDialog = ref(false);
</script>
